<script setup>
  import TagLabel from "./tag-label.vue";

  defineProps({
    modelValue: { type: Array, required: true },
    canRemove: { type: Boolean, required: false, default: true },
    canClick: { type: Boolean, required: false, default: true },
    size: { type: String, required: false, default: "medium" },
  });

  const emit = defineEmits(["tag-click", "remove", "advanced"]);
</script>

<template>
  <div class="tag-list-v">
    <TagLabel
      v-for="(tag, index) in modelValue"
      :key="index"
      :size="size"
      :tag-id="tag.id"
      :color="tag.color"
      :name="tag.name"
      :can-remove="canRemove"
      :can-click="canClick"
      :data-test-id="`tag-${tag.name}`"
      @remove="(tag) => emit('remove', tag)"
      @tag-click="(tag) => emit('tag-click', tag)"
      @advanced="(tag) => emit('advanced', tag)"
    />
  </div>
</template>

<style lang="scss" scoped>
  .tag-list-v {
    display: flex;
    gap: 0.3em;
    align-items: center;
    flex-wrap: wrap;
  }
</style>
